module.exports = __webpack_public_path__ + "static/ogpImage_ssd-single-c2e259cc1e25c66da604f723846896eb.png";